export default "__VITE_ASSET__Bo5XfFX8__"